export default __webpack_public_path__ + "static/media/no-data.2db708d4.png";